import EndpointFactory from '~~/app/factories/EndpointFactory';
import TenantEndpoint from '~~/app/auth/endpoints/TenantEndpoint';
import { ModelType } from '~~/app/base/schemas/BaseSchema';

export default async (): Promise<void> => {
    const { tenants, setTenants } = useAuthStore();
    if (tenants) return;

    const endpoint = EndpointFactory.make(ModelType.TENANTS) as TenantEndpoint;
    const response = await endpoint.index();
    if (response.data) {
        setTenants(response.data);
    }
};
